<template>
    <div>
        <span v-if="!isLoggedIn"
            ><LoginPage :dont-redirect="true"></LoginPage
        ></span>
        <span v-if="!canAccessThisRoute">
            <h1>Don't have access to this page.</h1>
        </span>
        <span :key="canSeePage" v-show="canSeePage">
            <slot></slot>
        </span>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import LoginPage from "./LoginPage";
import { canAccessState } from "../../grouppermissions/utils";

export default {
    components: {
        LoginPage,
    },

    data() {
        return {};
    },
    computed: {
        ...mapGetters("AuthModule", [
            "isLoggedIn",
            "permissions",
            "use_permissions",
        ]),
        canSeePage() {
            if (!this.isLoggedIn) {
                return false;
            }
            return this.canAccessThisRoute;
        },
        canAccessThisRoute() {
            if (!this.use_permissions) {
                return true;
            }

            if (this.permissions && this.$router.currentRoute.name) {
                return canAccessState(
                    this.permissions,
                    this.$router.currentRoute.name
                );
            }
            return false; // no entry
        },
    },
    methods: {},
};
</script>
